"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Permissions = require("../../constants/Permissions");
var _Permission = _interopRequireDefault(require("../../components/Permissions/Permission"));
var _PermissionTooltip = _interopRequireDefault(require("../../components/Permissions/PermissionTooltip"));
var _Checkbox = _interopRequireDefault(require("../../components/Checkbox/Checkbox"));
var _hooks = require("../../hooks");
var _globalTooltipDelay = require("../../utils/globalTooltipDelay");
var _SceneLayerChooserUtils = require("./SceneLayerChooserUtils");
var _SceneLayoutChooserItem = require("./SceneLayoutChooserItem.styled");
var _propComparators = require("../../utils/propComparators");
var _useTranslate2 = require("../../locales/useTranslate");
var _this = void 0;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// extend to define more permissions
var getViewPermissions = function getViewPermissions() {
  return [_Permissions.CHANGE_LAYOUTS];
};
var SceneLayoutChooserItem = function SceneLayoutChooserItem(_ref) {
  var enableFeature = _ref.enableFeature,
    layoutIndex = _ref.layoutIndex,
    selected = _ref.selected,
    onClick = _ref.onClick,
    thumbnail = _ref.thumbnail,
    title = _ref.title,
    available = _ref.available,
    isLayoutStaged = _ref.isLayoutStaged,
    layoutId = _ref.id,
    viewPermissions = _ref.viewPermissions,
    user = _ref.user;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var selectLayoutHandler = (0, _react.useCallback)(function () {
    if (enableFeature || isStudioLite) onClick();
  }, [enableFeature, isStudioLite, onClick]);
  var targetElementId = "layout-chooser-".concat(layoutIndex);
  var commonProps = {
    targetElementId: targetElementId,
    title: title,
    selected: selected,
    thumbnail: thumbnail,
    available: available,
    enableFeature: enableFeature,
    isLayoutStaged: isLayoutStaged,
    selectLayoutHandler: selectLayoutHandler,
    layoutId: layoutId,
    layoutIndex: layoutIndex
  };
  var LayoutUnavailableTooltip = function LayoutUnavailableTooltip(_ref2) {
    var available = _ref2.available,
      enableFeature = _ref2.enableFeature,
      layoutId = _ref2.layoutId,
      layoutIndex = _ref2.layoutIndex;
    var text = (0, _SceneLayerChooserUtils.getFeaturedLayoutIdText)(layoutId);
    var _useTranslate = (0, _useTranslate2.useTranslate)(),
      translate = _useTranslate.translate;
    var displayComponent = !available && (enableFeature || isStudioLite);
    if (displayComponent) {
      return /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
        delay: _globalTooltipDelay.TOOL_TIP_DELAY,
        placement: "bottom",
        style: _SceneLayoutChooserItem.ToolTipStyled,
        target: "layout-chooser-".concat(layoutIndex)
      }, translate(text));
    }
    return null;
  };
  var ComponentWithoutPermission = function ComponentWithoutPermission(_ref3) {
    var targetElementId = _ref3.targetElementId,
      title = _ref3.title,
      selected = _ref3.selected,
      thumbnail = _ref3.thumbnail,
      available = _ref3.available,
      enableFeature = _ref3.enableFeature,
      isLayoutStaged = _ref3.isLayoutStaged,
      selectLayoutHandler = _ref3.selectLayoutHandler,
      layoutId = _ref3.layoutId,
      layoutIndex = _ref3.layoutIndex;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SceneLayoutChooserItem.Wrapper, {
      id: targetElementId,
      "data-testid": "scene-layout-selector-".concat(title),
      "aria-labelledby": "".concat(selected ? "".concat(title, "LayoutSelected") : "".concat(title, "Layout")),
      onClick: selectLayoutHandler,
      selected: selected,
      thumbnail: thumbnail,
      available: available,
      enableFeature: enableFeature,
      isStudioLite: isStudioLite
    }, isLayoutStaged && /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      id: title,
      checked: isLayoutStaged,
      dataTestId: "stage-layout"
    })), /*#__PURE__*/_react["default"].createElement(LayoutUnavailableTooltip, {
      available: available,
      enableFeature: enableFeature,
      layoutId: layoutId,
      layoutIndex: layoutIndex
    }));
  };

  /**
   * This function is called by the permission wrapper to determine
   * if the featured should actually be enabled on the UI, given
   * the current user role permissions.
   *
   * @param {Boolean} enableFeature - Flag determining whether feature should be enabled.
   */
  var displayComponent = (0, _react.useCallback)(function (enableFeature) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ComponentWithoutPermission, (0, _extends2["default"])({}, commonProps, {
      enableFeature: enableFeature
    })), /*#__PURE__*/_react["default"].createElement(_PermissionTooltip["default"], {
      displayTooltip: !enableFeature,
      targetElementId: targetElementId
    }));
  }, [targetElementId, title, selected, thumbnail, available, isStudioLite, isLayoutStaged, selectLayoutHandler, layoutId, layoutIndex]);
  return isStudioLite ? /*#__PURE__*/_react["default"].createElement(ComponentWithoutPermission, commonProps) : /*#__PURE__*/_react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayComponent.bind(_this),
    viewPermissions: viewPermissions,
    user: user
  });
};
SceneLayoutChooserItem.propTypes = {
  id: _propTypes["default"].string,
  layoutIndex: _propTypes["default"].number,
  enableFeature: _propTypes["default"].bool,
  title: _propTypes["default"].string.isRequired,
  selected: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  thumbnail: _propTypes["default"].string,
  available: _propTypes["default"].bool,
  isLayoutStaged: _propTypes["default"].bool,
  viewPermissions: _propTypes["default"].object,
  user: _propTypes["default"].object
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SceneLayoutChooserItem, _propComparators.equalityComparator);